import { AspectRatio, Business } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import { ModalPendingStructureInvitation } from 'primary/activities/Modals/ModalPendingStructureInvitation';
import { Title } from 'primary/Components/Title/Title';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useRetrieveFromDomain } from 'primary/hooks/useRetrieveFromDomain';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const ButtonInvitationsStructures = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { structureMemberRepository } = useContextDependency();
  const [invitationList, , loading, retry] = useRetrieveFromDomain(
    () => structureMemberRepository.getPendingStructureInvitations(),
    undefined,
  );

  const afterSubmit = () => {
    retry();
    if (invitationList?.length && invitationList.length - 1 === 0) {
      setIsOpen(false);
    }
  };
  const { state } = useLocation();
  const modalAlreadyOpenFromState = useRef(false);
  useEffect(() => {
    if (
      !modalAlreadyOpenFromState.current &&
      !isOpen &&
      state?.openInviteStructurePending
    ) {
      setIsOpen(true);
      modalAlreadyOpenFromState.current = true;
    }
  }, [modalAlreadyOpenFromState.current, isOpen]);

  return (
    <div className={'-socialItems'}>
      <div className={'-iconWithNumber'}>
        <Business className={'-socialLogo'} />
        {!invitationList && <CircularProgress size={15} color={'info'} />}
        {invitationList && <span>{invitationList?.length ?? 0}</span>}
      </div>
      <div className={'-titleWithBtn'}>
        <Title title={'Invitations structures'} level={3} compensatePadding />
        <IconButton
          disabled={invitationList && invitationList.length <= 0}
          onClick={() => setIsOpen(true)}
        >
          <AspectRatio fontSize={'small'} />
        </IconButton>
      </div>

      {!invitationList && <CircularProgress size={15} color={'info'} />}
      {invitationList && (
        <ModalPendingStructureInvitation
          isOpen={isOpen}
          invitationList={invitationList}
          afterSubmit={afterSubmit}
          handleClose={() => setIsOpen(false)}
          loading={loading}
        />
      )}
    </div>
  );
};
